//**Consider adding the component to priority-style-react when the designs are finalized */

import React, {ReactNode} from 'react';
import classNames from 'classnames';

import styles from '../styles/draggableItem.module.scss';
import {ComponentBaseProperties, Icon, PriorityIcon} from '@priority-software/priority-style-react';

export interface DraggableProperties extends ComponentBaseProperties {
    dragHandleProps: any;
    draggableProps: any;
    innerRef: any;
    isDragged: boolean;
    inDrag: boolean;
    iconStyle?: string;
    children?: ReactNode;
    defaultIcon?: boolean;
}

export function DraggableItem(props: DraggableProperties) {
    const {
        draggableProps,
        dragHandleProps,
        innerRef,
        isDragged,
        inDrag,
        children,
        iconStyle,
        componentClasses,
        dataTestId,
        defaultIcon
    } = props;
    const componentClass = classNames(styles.component, componentClasses, {
        [styles.dragged]: isDragged,
        [styles.inDrag]: inDrag
    });
    const iconClass = classNames(styles.dragIconContainer, iconStyle);

    return (
        <div
            ref={innerRef}
            {...draggableProps}
            className={componentClass}
            data-test-id={dataTestId}
        >
            {defaultIcon && (
                <div className={iconClass} {...dragHandleProps}>
                    <Icon icon={PriorityIcon.reorder} skin="standart" />
                </div>
            )}
            {children}
        </div>
    );
}
